import React from 'react'
import Tab, { TabItem } from '@/components/tab/tab'
import { getBEMCls } from '@/utils/classname'
import { MainHeader, Column, Expaned } from '@/components/layout/layout'
import PurChaseContent, { GOODS_PURCHASE_ORDER, GOODS_SUPPLIER } from './router'

import { RouteComponentProps } from 'react-router'

const PurchaseManage = (props: RouteComponentProps) => {
    const tabList: TabItem[] = [
        {
            id: 0,
            name: '供货商',
            route: GOODS_SUPPLIER,
        },
        {
            id: 1,
            name: '采购单',
            route: GOODS_PURCHASE_ORDER,
            perssion: 31,
        },
    ]
    const getCls = (el?: string, m?: string) => getBEMCls('purchase-order', el, m)

    return (
        <Column className={getCls()}>
            <MainHeader>
                <Tab tabList={tabList} />
            </MainHeader>
            <Expaned className={getCls('content')}>
                <PurChaseContent {...props} />
            </Expaned>
        </Column>
    )
}

export default PurchaseManage
